import { initReactI18next as i } from "react-i18next";
import { defaultOptions as e } from "./index25.mjs";
const m = (t, n) => (t.use(i).init({
  ...e,
  ...n
}), {
  i18n: t
});
export {
  m as initI18nInstance
};
